import { Theme, TextField, InputAdornment } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import {
  CcfBox,
  CcfDeboucedInput,
  CcfEditWithPenIcon,
  CcfSearchIcon,
  CcfTextField,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ccfConversationsActions,
  getAgentGroups,
  getAgents,
} from '../+state/ccf-conversations.slice';
import {
  agentGroupsData,
  agentsData,
} from '../mock-data/agent-conversations-mock-data';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      padding: '6px',
      // borderRight: '1px solid #e3e9ee',
      opacity: '1',
    },
    textField: {
      background: theme.palette.background.paper,
      '& > .MuiInputBase-root': {
        height: 32,
        fontSize: 'small',
      },
    },
    captionText: {
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '12px',
      lineHeight: '16px',
      color: '#333333',
    },
  })
);

/**
 * Component for Conversation search
 * @example <ConversationSearch />
 * @returns
 */
export const ConversationAppSearch = ({
  showSearchBox,
}: {
  showSearchBox: boolean;
}) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const [searchTxt, setSearchTxt] = useState('');
  const agents = useSelector(getAgents);
  const agentGroups = useSelector(getAgentGroups);
  const { updateSelectedAgent, updateAgentGroups, updateAgents } =
    ccfConversationsActions;

  /**
   * Handler for search agent
   * @example searchAgentHandler()
   */
  const searchAgentHandler = (e: any) => {
    const searchText = e.target.value.toLowerCase();
    setSearchTxt(searchText);

    /**
     * Function to filter items
     * @example filterItems()
     */
    const filterItems = (items: any[], key: string) =>
      items.filter((item) => item.name.toLowerCase().includes(searchText));

    const filteredAgents = filterItems(agentsData, 'name');
    const filteredAgentGroups = filterItems(agentGroupsData, 'name');

    if (searchText) {
      dispatch(updateAgents({ filteredAgents, type: 'filter' }));
      dispatch(updateAgentGroups({ filteredAgentGroups, type: 'filter' }));
    } else {
      dispatch(updateAgents({ type: 'reset' }));
      dispatch(updateAgentGroups({ type: 'reset' }));
      dispatch(
        updateSelectedAgent({ agent: agentsData[0], type: 'favourite' })
      );
    }
  };

  return (
    <section className={styles.header}>
      <CcfBox height={'30px'} display={'flex'} justifyContent={'flex-end'}>
        <CcfEditWithPenIcon />
      </CcfBox>
      {showSearchBox ? (
        <CcfDeboucedInput
          size="small"
          style={{
            background: 'white',
          }}
          value={searchTxt}
          onChange={(e) => searchAgentHandler(e)}
          className={styles.textField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CcfSearchIcon />
              </InputAdornment>
            ),
          }}
          placeholder="Search"
          variant="outlined"
          fullWidth
          delay={1500}
        />
      ) : (
        <div style={{ height: '33px', display: 'flex', alignItems: 'center' }}>
          <CcfTypography className={styles.captionText}>
            Currently Online |12
          </CcfTypography>
        </div>
      )}
    </section>
  );
};
